var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCashCircle = function SvgCashCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    stroke: "#000",
    baseProfile: "tiny",
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252 128c0 68.4-55.6 124-124 124S4 196.4 4 128 59.6 4 128 4s124 55.6 124 124zm-77.7 27.6c0-26-27.8-33.4-39.8-36.8-22.7-6.3-24.6-14.5-24.3-18.7.8-10.2 12-12.7 22.4-10.5 8.2 1.8 16.6 6.6 21.3 10.3l14.9-17.4c-7.3-5-16.7-11.5-30.4-14.1V51.5h-21.7v16.3c-21 1.6-35 14.8-35 32.9 0 17.7 12.8 26 25.6 32.2 10.7 5.1 40.5 10.4 38.8 23.9-.9 7.3-8.7 12.7-21.6 11.1-11.2-1.4-23.2-10.8-23.2-10.8l-16.4 16.3c9.9 8 20.4 13 31.8 15.3v15.9h21.7v-15.1c20.7-2.3 35.9-16.4 35.9-33.9z"
  })));
};
export default SvgCashCircle;